type ToggleSliderProps = {
    gridViewState: boolean,
    setGridViewState: (value: boolean) => void
    leftLabel: string;
    rightLabel: string;
    iconLeft?: preact.ComponentChildren;
    iconRight?: preact.ComponentChildren;
    cssClass?: string;
    hideTextOnMobile?: boolean;
};

export function SlideToggle({
                                gridViewState,
                                setGridViewState,
                                leftLabel,
                                rightLabel,
                                iconLeft,
                                iconRight,
                                cssClass,
                                hideTextOnMobile = false
                            }: ToggleSliderProps) {

    const leftToggleClasses = (
        iconLeft: preact.ComponentChildren,
        hideTextOnMobile: boolean,
        gridViewState: boolean,
    ): string => {
        if(typeof iconLeft === 'undefined') {
            return 'inline-block'
        } else {
            if(hideTextOnMobile && !gridViewState) {
                return 'hidden lg:ml-1 lg:inline-block';
            } else {
                return 'hidden sm:ml-1 sm:inline-block'
            }
        }
    }

    const rightToggleClasses = (
        iconRight: preact.ComponentChildren,
        hideTextOnMobile: boolean,
        gridViewState: boolean,
    ): string => {
        if(typeof iconRight === 'undefined') {
            return 'inline-block'
        } else {
            if(hideTextOnMobile && gridViewState) {
                return 'hidden lg:ml-1 lg:inline-block';
            } else {
                return 'hidden sm:ml-1 sm:inline-block'
            }
        }
    }

    return (
        <div
            tabIndex={0}
            className={`
            relative h-11 overflow-hidden 
            flex items-center
            justify-between
            select-none cursor-pointer rounded-10px 
            bg-theme-gray-light p-1 gap-1 ${cssClass ?? ''}`}>

            {/* Left option */}
            <div
                role="radio"
                aria-checked={gridViewState}
                tabIndex={0}
                onClick={() => setGridViewState(true)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        setGridViewState(true);
                    }
                }}
                className={`
                    relative h-full z-10
                    flex items-center justify-center
                    rounded-8px
                    text-13px 
                    leading-none font-semibold
                    ${gridViewState ? 'bg-white flex-[2]  px-1 sm:px-2 lg:px-3' : 'px-2 sm:px-2 lg:px-3 flex-1'}
                `}
            >
                {iconLeft ?? ''}
                <span className={`${leftToggleClasses(iconLeft, hideTextOnMobile, gridViewState)}`}
                >{leftLabel}</span>
            </div>

            {/* Right option */}
            <div
                role="radio"
                aria-checked={!gridViewState}
                tabIndex={0}
                onClick={() => setGridViewState(false)}
                className={`
                    relative h-full z-10
                    flex items-center justify-center
                    rounded-8px
                    text-13px
                    leading-none font-semibold
                    ${!gridViewState ? 'bg-white flex-[2] px-1 sm:px-2 lg:px-3' : 'px-1 sm:px-2 lg:px-3 flex-1'}
                `}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        setGridViewState(false);
                    }
                }}
            >
                {iconRight ?? ''}
                <span className={`${rightToggleClasses(iconRight, hideTextOnMobile, gridViewState)}`}
                >{rightLabel}</span>
            </div>
        </div>
    );
}
